import { Navigate } from 'react-router-dom';
import PageLoader from '@/components/PageLoader';
import { useProgramApplication } from '@/hooks/useProgramApplication';

// Koda gömülü başvuru sayfalarından kalan adresleri, o programın YAYINDAKİ
// başvuru formuna taşır (/form/<id>). Form yayında değilse programın bilgi
// sayfasına düşer. Böylece paylaşılmış eski bağlantılar kırılmaz.
//
// Ayar gelene kadar beklenir: aksi halde önce bilgi sayfasına atıp sonra forma
// zıplardık (bkz. ApplicationRoute'taki aynı gerekçe).
const ProgramFormRedirect = ({
  slug,
  fallback,
}: {
  slug: string;
  fallback: string;
}) => {
  const { loading, applyPath } = useProgramApplication(slug);
  if (loading) return <PageLoader />;
  return <Navigate to={applyPath ?? fallback} replace />;
};

export default ProgramFormRedirect;
